export const parcelStatuses = {
  created: 'CREATED',
  invoiced: 'INVOICED',
  paid: 'PAID',
  prepaid: 'PREPAID',
  uploaded: 'UPLOADED',
  void: 'VOID',
};
